"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4483],{

/***/ 92268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BestsellersBlock_BestsellersBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__(22175);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(99214);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/navigation/Tabs/Tabs.tsx + 4 modules
var Tabs = __webpack_require__(22958);
// EXTERNAL MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/ProductList.tsx + 1 modules
var ProductList = __webpack_require__(21907);
;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Shop best sellers"
    },
    // TODO seems a very common pattern - added on 04.02.2022 by sonatskiy
    perfumes: {
        en: "Perfumes"
    },
    colognes: {
        en: "Colognes"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/BestsellersBlock.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}














var tabIds = {
    perfumes: "perfumes",
    colognes: "colognes"
};
var BestsellersBlock = function(props) {
    var id = props.id, className = props.className, title = props.title, limit = props.limit, totalLimit = props.totalLimit, offset = props.offset, buttonProps = props.buttonProps, fetchMoreButtonTitle = props.fetchMoreButtonTitle, _props_withoutLink = props.withoutLink, withoutLink = _props_withoutLink === void 0 ? true : _props_withoutLink, withRetailPrice = props.withRetailPrice, fetchMoreButtonStyle = props.fetchMoreButtonStyle;
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useUser = (0,user/* useUser */.a)(), gender = _useUser.gender, isLoggedIn = _useUser.isLoggedIn;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useEntry = _sliced_to_array((0,useEntry/* default */.Z)({
        once: true,
        observerProps: {
            rootMargin: "25%"
        }
    }), 2), ref = _useEntry[0], entry = _useEntry[1];
    var isSectionVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    // don't make strict assertion for non-authorized users because of different urls
    var isMale = isLoggedIn ? gender === "MALE" : /\/men/.test(pathname);
    var defaultTab = isMale ? tabIds.colognes : tabIds.perfumes;
    var tabs = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
            id: tabIds.perfumes,
            title: messages.perfumes,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                limit: limit,
                totalLimit: totalLimit,
                offset: offset,
                catalogueName: "perfumes",
                buttonProps: buttonProps,
                isVisible: isSectionVisible,
                withoutLink: withoutLink,
                withRetailPrice: withRetailPrice,
                fetchMoreButtonTitle: fetchMoreButtonTitle,
                fetchMoreButtonStyle: fetchMoreButtonStyle
            })
        }, "perfumes"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z.Content, {
            id: tabIds.colognes,
            title: messages.colognes,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                limit: limit,
                totalLimit: totalLimit,
                offset: offset,
                catalogueName: "colognes",
                buttonProps: buttonProps,
                isVisible: isSectionVisible,
                withoutLink: withoutLink,
                withRetailPrice: withRetailPrice,
                fetchMoreButtonTitle: fetchMoreButtonTitle,
                fetchMoreButtonStyle: fetchMoreButtonStyle
            })
        }, "colognes")
    ];
    if (isMale) {
        tabs.reverse();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        ref: ref,
        id: id,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title || messages.title,
                style: isMobile ? "h4" : "h3",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                className: isMobile ? "mt-32" : "mt-40",
                defaultActiveTab: defaultTab,
                children: tabs
            })
        ]
    });
};
/* harmony default export */ const BestsellersBlock_BestsellersBlock = (/*#__PURE__*/react.memo(BestsellersBlock));


/***/ }),

/***/ 21907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductList_ProductList)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(7362);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(69219);
// EXTERNAL MODULE: ./src/compositions/productLists/FetchMoreButtonProductList/FetchMoreButtonProductList.tsx
var FetchMoreButtonProductList = __webpack_require__(28645);
;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/messages.ts
/* harmony default export */ const messages = ({
    buttonTitle: {
        en: "View more scents"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BestsellersBlock/components/ProductList/ProductList.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var ProductList = function(props) {
    var _data_products;
    var catalogueName = props.catalogueName, buttonProps = props.buttonProps, isVisible = props.isVisible, fetchMoreButtonTitle = props.fetchMoreButtonTitle, fetchMoreButtonStyle = props.fetchMoreButtonStyle, withDetailedMobileCards = props.withDetailedMobileCards, withoutLink = props.withoutLink, _props_withRetailPrice = props.withRetailPrice, withRetailPrice = _props_withRetailPrice === void 0 ? false : _props_withRetailPrice, limit = props.limit, _props_offset = props.offset, offset = _props_offset === void 0 ? 0 : _props_offset, _props_totalLimit = props.totalLimit, totalLimit = _props_totalLimit === void 0 ? 72 : _props_totalLimit;
    var _useCatalogueId = (0,useCatalogueId/* default */.Z)({
        catalogueName: catalogueName
    }), catalogueId = _useCatalogueId.catalogueId, isFetchingCatalogue = _useCatalogueId.isFetching;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var productsLimit = limit || (isMobile ? 12 : 6);
    var variables = (0,react.useMemo)(function() {
        return {
            id: catalogueId,
            input: {
                limit: productsLimit,
                offset: offset,
                productsFeed: "PICK_ORDER_BRAND_PARTNERS"
            },
            withCount: true,
            withRetailPrice: withRetailPrice
        };
    }, [
        catalogueId,
        offset,
        productsLimit,
        withRetailPrice
    ]);
    var _useCatalogueProducts = (0,useCatalogueProducts/* default */.Z)({
        variables: variables,
        ssr: false,
        notifyOnNetworkStatusChange: true,
        skip: !catalogueId || !isVisible
    }), data = _useCatalogueProducts.data, isFetching = _useCatalogueProducts.isFetching, fetchMore = _useCatalogueProducts.fetchMore;
    var handleFetchMore = (0,react.useCallback)(function() {
        var _data_products;
        (0,analytics/* track */.j)("Show more products click", {
            placement: "Bestsellers"
        });
        fetchMore({
            variables: _object_spread_props(_object_spread({}, variables), {
                input: _object_spread_props(_object_spread({}, variables.input), {
                    offset: data === null || data === void 0 ? void 0 : (_data_products = data.products) === null || _data_products === void 0 ? void 0 : _data_products.length
                })
            })
        });
    }, [
        data === null || data === void 0 ? void 0 : (_data_products = data.products) === null || _data_products === void 0 ? void 0 : _data_products.length,
        fetchMore,
        variables
    ]);
    var totalCount = Math.min(data === null || data === void 0 ? void 0 : data.count, totalLimit);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FetchMoreButtonProductList/* default */.Z, {
        className: "mt-24",
        products: data === null || data === void 0 ? void 0 : data.products,
        totalCount: totalCount,
        isFetching: !isVisible || isFetchingCatalogue || isFetching,
        fetchSkeletonsAmount: productsLimit,
        fetchMoreButtonTitle: fetchMoreButtonTitle || messages.buttonTitle,
        fetchMoreButtonStyle: fetchMoreButtonStyle || "secondary",
        buttonProps: buttonProps,
        fetchMore: handleFetchMore,
        withoutLink: withoutLink,
        withRetailPrice: withRetailPrice,
        withDetailedMobileCards: withDetailedMobileCards,
        excludeLabels: [
            "BESTSELLER",
            "HOLIDAY_SALE",
            "PLUS_FREE_GIFT"
        ]
    });
};
/* harmony default export */ const ProductList_ProductList = (ProductList);


/***/ }),

/***/ 35303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BottomBanner_BottomBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/banners/HeroBase/HeroBase.tsx + 2 modules
var HeroBase = __webpack_require__(30248);
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Over 700 fragrances (and counting!) are waiting for you"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_5052f0.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_134ba8.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BottomBanner/BottomBanner.tsx






var BottomBanner = function(param) {
    var className = param.className, button = param.button, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBase/* default */.Z, {
        className: className,
        title: message || messages.title,
        desktopImage: bg_desktop_namespaceObject,
        mobileImage: bg_mobile_namespaceObject,
        button: button,
        desktopContentAtTop: true,
        wideMT: false,
        wideMB: true,
        "data-testid": "bottomBanner"
    });
};
/* harmony default export */ const BottomBanner_BottomBanner = (BottomBanner);


/***/ }),

/***/ 15743:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BrandsQualityBlock_BrandsQualityBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Top curated fragrances"
    },
    text: {
        en: "We offer the best designer and niche fragrances on the market selected by our team of experts."
    },
    note: {
        en: 'And many more luxury brands to&#32;<br class="onlyMobile" />choose from.'
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-desktop.jpg
const bg_0_desktop_namespaceObject = __webpack_require__.p + "images/bg-0-desktop_aef261.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-desktop.jpg?src-loader&size

/* harmony default export */ const bg_0_desktopsrc_loader_size = ({ src: bg_0_desktop_namespaceObject, aspect: 1.4753246753246754, width: 1136, height: 770 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-mobile.jpg
const bg_0_mobile_namespaceObject = __webpack_require__.p + "images/bg-0-mobile_4d6c11.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/bg-0-mobile.jpg?src-loader&size

/* harmony default export */ const bg_0_mobilesrc_loader_size = ({ src: bg_0_mobile_namespaceObject, aspect: 1.3, width: 832, height: 640 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-desktop.png
const brands_desktop_namespaceObject = __webpack_require__.p + "images/brands-desktop_50b547.png";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-desktop.png?src-loader&size

/* harmony default export */ const brands_desktopsrc_loader_size = ({ src: brands_desktop_namespaceObject, aspect: 38.724137931034484, width: 2246, height: 58 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-mobile.png
const brands_mobile_namespaceObject = __webpack_require__.p + "images/brands-mobile_a3ee3b.png";
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/images/brands-mobile.png?src-loader&size

/* harmony default export */ const brands_mobilesrc_loader_size = ({ src: brands_mobile_namespaceObject, aspect: 5.2105263157894735, width: 792, height: 152 });
;// CONCATENATED MODULE: ./src/compositions/landings/BrandsQualityBlock/BrandsQualityBlock.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var BrandsQualityBlock = function(props) {
    var className = props.className, _props_button = props.button, button = _props_button === void 0 ? null : _props_button, subtitle = props.subtitle, title = props.title, text = props.text, customMobileImage = props.mobileImage, customDesktopImage = props.desktopImage;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var mobileImage = customMobileImage || bg_0_mobilesrc_loader_size;
    var desktopImage = customDesktopImage || bg_0_desktopsrc_loader_size;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)(className, "bg-light-beige"),
            "data-testid": "brandsSection",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                    aspect: mobileImage.aspect,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: mobileImage.src,
                        lazy: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-16 pt-24 text-center",
                    children: [
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mb-8",
                            message: subtitle,
                            style: "eye2",
                            color: "gold-70"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: title || messages.title,
                            style: "h4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: text || messages.text,
                            style: "p3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread_props(_object_spread({
                            className: "mt-24 w-full"
                        }, brands_mobilesrc_loader_size), {
                            lazy: true,
                            alt: "Bvlgari, Tocca, Kenneth Cole, Michael Kors, Marc Jacobs, Balenciaga"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: messages.note,
                            style: "p3",
                            html: true
                        }),
                        button
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: className,
        "data-testid": "brandsSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between bg-light-beige",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-464 py-32 pl-64 pr-32",
                        children: [
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mb-8",
                                message: subtitle,
                                style: "eye2",
                                color: "gold-70"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: title || messages.title,
                                style: "h3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mt-24",
                                message: text || messages.text,
                                style: "p3"
                            }),
                            button
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                        className: "w-6/12",
                        aspect: desktopImage.aspect,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: desktopImage.src,
                            lazy: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread_props(_object_spread({
                className: "mt-24 w-full px-12"
            }, brands_desktopsrc_loader_size), {
                lazy: true,
                alt: "Bvlgari, Michael Kors, Marc Jacobs, Tocca, Balenciaga"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24 text-center",
                message: messages.note,
                style: "p1",
                html: true
            })
        ]
    });
};
/* harmony default export */ const BrandsQualityBlock_BrandsQualityBlock = (/*#__PURE__*/react.memo(BrandsQualityBlock));


/***/ }),

/***/ 85201:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ContinueStickyBar_ContinueStickyBar)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Logo/Logo.tsx
var Logo = __webpack_require__(1041);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/buttons/SubscribeButton/SubscribeButton.tsx
var SubscribeButton = __webpack_require__(6658);
// EXTERNAL MODULE: ./src/pages/landing/View/components/GetStartedButton/GetStartedButton.tsx + 1 modules
var GetStartedButton = __webpack_require__(86527);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ./src/containers/ProductsInQueueProvider/ProductsInQueueProvider.tsx
var ProductsInQueueProvider = __webpack_require__(36122);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/components/QueueItems.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const QueueItems_module = ({"fadeIn":"abumMx","translateImage":"ppSvYu","translateDigits":"F16cHQ"});
;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/components/QueueItems.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}











var QueueItems = function(param) {
    var className = param.className;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var queueItems = (0,ProductsInQueueProvider/* useProductsInQueueContext */.X)().queueItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex", isMobile ? "gap-4" : "gap-8"),
        children: [
            queueItems.slice(0, 2).map(function(item, index) {
                var _item_product, _item_product1;
                return item && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)(QueueItems_module.fadeIn, "flex items-center justify-center overflow-hidden rounded bg-white", isMobile ? "h-32 w-32" : "h-48 w-48"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                        className: (0,clsx/* default */.Z)(QueueItems_module.translateImage, "w-full"),
                        src: ((_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.rebrandImage) || ((_item_product1 = item.product) === null || _item_product1 === void 0 ? void 0 : _item_product1.image),
                        bgColor: "white"
                    })
                }, index);
            }),
            queueItems.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)(QueueItems_module.fadeIn, "overflow-hidden rounded-full bg-gold-70", isMobile ? "ml-8 h-32 w-32" : "h-48 w-48"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountPlusDigits, {
                    initialCount: queueItems.length - 3
                })
            })
        ]
    });
};
var CountPlusDigits = function(param) {
    var initialCount = param.initialCount;
    var _useState = _sliced_to_array((0,react.useState)(function() {
        return Math.min(initialCount, 99);
    }), 2), currentPlusCount = _useState[0], setCurrentPlusCount = _useState[1];
    var handleAnimationEnd = function() {
        setCurrentPlusCount(function(prevCount) {
            return Math.min(prevCount + 1, 99);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(QueueItems_module.translateDigits, "h-full w-full"),
        onAnimationEnd: handleAnimationEnd,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: (0,clsx/* default */.Z)("flex h-full w-full items-center justify-center", currentPlusCount === 0 && "opacity-0"),
                message: "+".concat(currentPlusCount),
                style: "t4",
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex h-full w-full items-center justify-center",
                message: "+".concat(currentPlusCount + 1),
                style: "t4",
                color: "white"
            })
        ]
    }, initialCount);
};
/* harmony default export */ const components_QueueItems = (/*#__PURE__*/react.memo(QueueItems));

;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/messages.ts
/* harmony default export */ const ContinueStickyBar_messages = ({
    faq: {
        en: "FAQ"
    }
});

;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/ContinueStickyBar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ContinueStickyBar_module = ({"root":"uMmluY","visible":"K_dD6A"});
;// CONCATENATED MODULE: ./src/compositions/landings/ContinueStickyBar/ContinueStickyBar.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var ContinueStickyBar = function(props) {
    var isVisible = props.isVisible, desktopText = props.desktopText, continueButtonMessage = props.continueButtonMessage, eventDiscountText = props.eventDiscountText, customButton = props.customButton, coupon = props.coupon, onContinue = props.onContinue;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var isMountedRef = (0,react.useRef)(false);
    var isStickyCtaWithQueueEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.homeStickyCtaWithQueue) === "b";
    var handleContinueClick = (0,react.useCallback)(function() {
        (0,analytics/* track */.j)("Banner click", {
            placement: "Sticky bar",
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: coupon
        });
        if (typeof onContinue === "function") {
            onContinue();
        }
    }, [
        eventDiscountText,
        coupon,
        onContinue
    ]);
    var handleFaqClick = (0,react.useCallback)(function() {
        (0,analytics/* track */.j)("FAQ link click", {
            placement: "Sticky bar"
        });
        (0,manager/* openModal */.h7)("faqModal");
    }, []);
    (0,react.useEffect)(function() {
        isMountedRef.current = true;
    }, [
        isVisible
    ]);
    var rootClassName = (0,clsx/* default */.Z)(isStickyCtaWithQueueEnabled && isMobile ? "flex items-center justify-between pl-16 pr-8" : isMobile ? "grid grid-cols-2" : "bg-gold-30 py-24", ContinueStickyBar_module.root, isVisible && ContinueStickyBar_module.visible, isMountedRef.current ? "" : "hidden", "fixed inset-x-0 top-0 z-floating-header");
    var primaryButton;
    if (customButton) {
        var ButtonComponent = (customButton === null || customButton === void 0 ? void 0 : customButton.actionType) === "subscribe" ? SubscribeButton/* default */.Z : GetStartedButton/* default */.Z;
        var buttonProps = _object_spread({
            size: 56,
            width: isMobile ? null : 240,
            className: "bg-deep-purple"
        }, customButton);
        primaryButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, _object_spread_props(_object_spread({}, buttonProps), {
            placement: "Brand block"
        }));
    } else {
        primaryButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (0,clsx/* default */.Z)(isStickyCtaWithQueueEnabled && isMobile ? "!border-0" : "!bg-deep-purple"),
            noPadding: isStickyCtaWithQueueEnabled && isMobile,
            title: continueButtonMessage || messages/* default */.Z["continue"],
            inlineIcon: "32/arrow-right",
            to: links/* default */.ZP.subscribe,
            size: 56,
            width: isMobile ? null : 240,
            style: isStickyCtaWithQueueEnabled && isMobile ? "secondary" : "primary",
            onClick: handleContinueClick,
            "data-testid": "subscribeButton"
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)(rootClassName, isStickyCtaWithQueueEnabled && "bg-gold-30"),
                children: [
                    isStickyCtaWithQueueEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QueueItems, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: ContinueStickyBar_messages.faq,
                        size: 56,
                        style: "gold-30",
                        onClick: handleFaqClick,
                        "data-testid": "faqButton"
                    }),
                    primaryButton
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "flex items-center justify-end",
            children: [
                desktopText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mr-auto",
                    message: desktopText,
                    style: "p2",
                    html: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                    className: "mr-auto",
                    color: "black"
                }),
                isStickyCtaWithQueueEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QueueItems, {
                    className: "mr-16"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "mr-16",
                    title: ContinueStickyBar_messages.faq,
                    size: 56,
                    width: 240,
                    style: "secondary",
                    onClick: handleFaqClick,
                    "data-testid": "faqButton"
                }),
                primaryButton
            ]
        })
    });
};
/* harmony default export */ const ContinueStickyBar_ContinueStickyBar = (/*#__PURE__*/react.memo(ContinueStickyBar));


/***/ }),

/***/ 37349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HowItWorksBlock_HowItWorksBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/ScrollableContainer/ScrollableContainer.tsx
var ScrollableContainer = __webpack_require__(71462);
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Here's how it works:"
    },
    slides: [
        {
            title: {
                en: "1. Pick a scent"
            },
            text: {
                en: "Choose what you'd like to try from our best sellers — you'll get access to our full catalog after subscribing."
            }
        },
        {
            title: {
                en: "2. Activate your subscription"
            },
            text: {
                en: "Once your subscription is active, the 8 mL bottle of your choosing will be sent directly to you."
            }
        },
        {
            title: {
                en: "3. Receive your fragrance"
            },
            text: {
                en: "Your first bottle will come dressed in a free atomizer case, and the 8 mL bottle holds roughly 120 sprays, which should last until your next order."
            }
        }
    ]
});

;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-1.jpg
const how_1_namespaceObject = __webpack_require__.p + "images/how-1_9f7abc.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-2.jpg
const how_2_namespaceObject = __webpack_require__.p + "images/how-2_7dcc25.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/how-3.jpg
const how_3_namespaceObject = __webpack_require__.p + "images/how-3_dcf981.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-1.jpg
const restyle_how_1_namespaceObject = __webpack_require__.p + "images/how-1_e81c41.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-2.jpg
const restyle_how_2_namespaceObject = __webpack_require__.p + "images/how-2_e0bbaa.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/images/restyle/how-3.jpg
const restyle_how_3_namespaceObject = __webpack_require__.p + "images/how-3_32e956.jpg";
;// CONCATENATED MODULE: ./src/compositions/landings/HowItWorksBlock/HowItWorksBlock.tsx














var HowItWorksBlock_images = [
    how_1_namespaceObject,
    how_2_namespaceObject,
    how_3_namespaceObject
];
var restyleImages = [
    restyle_how_1_namespaceObject,
    restyle_how_2_namespaceObject,
    restyle_how_3_namespaceObject
];
var aspect = 368 / 200;
var getDefaultItems = function(isRestyle) {
    return messages.slides.map(function(param, index) {
        var title = param.title, text = param.text;
        return {
            title: title,
            text: text,
            image: isRestyle ? restyleImages[index] : HowItWorksBlock_images[index]
        };
    });
};
var HowItWorksBlock = function(props) {
    var children = props.children, className = props.className, title = props.title, items = props.items, restyleDefaultImages = props.restyleDefaultImages, _props_withScrollableOnMobile = props.withScrollableOnMobile, withScrollableOnMobile = _props_withScrollableOnMobile === void 0 ? true : _props_withScrollableOnMobile;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var finalItems = items || getDefaultItems(restyleDefaultImages);
    var slidesNode = finalItems.map(function(param) {
        var title = param.title, text = param.text, image = param.image;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "snap-start scroll-ml-16 text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                    aspect: aspect,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image,
                        lazy: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-16",
                    message: title,
                    style: "h6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-8",
                    message: text,
                    style: "p2"
                })
            ]
        }, image);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)("text-center", className),
        "data-testid": "howItWorksSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-32",
                message: title || messages.title,
                style: isMobile ? "h5" : "h3"
            }),
            isMobile ? withScrollableOnMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                className: "grid snap-x snap-mandatory auto-cols-[356rem] grid-flow-col gap-x-16",
                children: slidesNode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-flow-row gap-32",
                children: slidesNode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-3 gap-16",
                children: slidesNode
            }),
            children
        ]
    });
};
/* harmony default export */ const HowItWorksBlock_HowItWorksBlock = (/*#__PURE__*/react.memo(HowItWorksBlock));


/***/ })

}]);